module.exports = __webpack_public_path__ + "img/47.60ba9eed.png";